
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import AppHeaderV2 from '@/components/common/AppHeaderV2';
import Body from './Body';
import BodyPc from './BodyPc';
import PaginatedReviewResourceView from '@/mixins/PaginatedReviewResourceView';

export default {
  i18nComponentKey: 'WidgetReviewsListV3.components.ListV3',
  name: 'ListV3',
  components: { AppHeaderV2, Body, BodyPc },
  mixins: [PaginatedReviewResourceView],
  computed: {
    ...mapState('widget', ['widget']),
    ...mapGetters('widget', [
      'isMobileViewport',
      'appHeaderV2AndTitleShowable'
    ]),
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapGetters('reviewSettings', ['isAuthorDisplayTypeUserGrade']),
    defaultResourceParams() {
      return {
        fields: [
          'has_media',
          'reviews.evaluation_properties',
          'reviews.ai_summary',
          'reviews.with_parent_reviews',
          'reviews.customer_properties',
          this.isAuthorDisplayTypeUserGrade ? 'reviews.brand_user_grade' : '',
          this.reviewSettings.use_comments &&
          this.reviewSettings.always_show_comments
            ? 'reviews.comments'
            : ''
        ]
          .filter(v => v)
          .join(',')
      };
    }
  },
  created() {
    this.SET_EDIT_OR_DELETE_CALLBACK(() => this.searchResource());
  },
  beforeDestroy() {
    this.SET_EDIT_OR_DELETE_CALLBACK(null);
  },
  methods: {
    ...mapMutations('review', ['SET_EDIT_OR_DELETE_CALLBACK']),
    ...mapActions('widget', ['openShowReviewPopup']),
    submit(params) {
      this.searchResource(params);
    }
  }
};
